export type WeddingUrgencyTone = 'neutral' | 'amber' | 'muted';

export type WeddingUrgency = {
  labelKey: string;
  params?: Record<string, number>;
  tone: WeddingUrgencyTone;
};

const MS_PER_DAY = 24 * 60 * 60 * 1000;

function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function formatWeddingUrgency(weddingDate: Date, now: Date = new Date()): WeddingUrgency {
  const wedding = startOfLocalDay(weddingDate);
  const today = startOfLocalDay(now);
  const diffMs = wedding.getTime() - today.getTime();
  const diffDays = Math.round(diffMs / MS_PER_DAY);

  if (diffDays < 0) {
    return { labelKey: 'customers.wedding.past', tone: 'muted' };
  }

  const sameMonth =
    wedding.getFullYear() === today.getFullYear() && wedding.getMonth() === today.getMonth();
  if (sameMonth) {
    return { labelKey: 'customers.wedding.this_month', tone: 'amber' };
  }

  if (diffDays < 28) {
    const weeks = Math.max(1, Math.ceil(diffDays / 7));
    return { labelKey: 'customers.wedding.in_weeks', params: { count: weeks }, tone: 'amber' };
  }

  const months = Math.max(1, Math.round(diffDays / 30));
  return { labelKey: 'customers.wedding.in_months', params: { count: months }, tone: 'neutral' };
}

export function weddingUrgencyToneClass(tone: WeddingUrgencyTone): string {
  switch (tone) {
    case 'amber':
      return 'text-amber-700';
    case 'muted':
      return 'text-gray-400';
    default:
      return 'text-gray-500';
  }
}
